import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import AdvantagesSection from './components/AdvantagesSection';
import MembershipSection from './components/MembershipSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'hth官方平台',
    url: 'https://www.hth-platform.com/',
    description: 'hth是您信赖的首选平台，提供正品保障、极速响应与全方位服务支持。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.hth-platform.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'hth官方平台',
    url: 'https://www.hth-platform.com/',
    description: '正品保障与极速服务的首选平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-XXX-XXXX',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'hth官方平台 - 首页',
    description: 'hth官方平台首页，提供正品保障、极速响应与全方位服务支持。',
    url: 'https://www.hth-platform.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: 'hth官方平台',
      url: 'https://www.hth-platform.com/',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />
      <ScrollToTop />
      <div className="min-h-screen">
        <Navbar />
        <main>
          <HeroSection />
          <StatsSection />
          <AdvantagesSection />
          <MembershipSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}